import { render, staticRenderFns } from "./safetyActionTargetDetailResult.vue?vue&type=template&id=4c34c148"
import script from "./safetyActionTargetDetailResult.vue?vue&type=script&lang=js"
export * from "./safetyActionTargetDetailResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c34c148')) {
      api.createRecord('4c34c148', component.options)
    } else {
      api.reload('4c34c148', component.options)
    }
    module.hot.accept("./safetyActionTargetDetailResult.vue?vue&type=template&id=4c34c148", function () {
      api.rerender('4c34c148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sat/safetyActionTargetDetailResult.vue"
export default component.exports